import { api } from "../../utils/api";

export const getClientsIncome = async (data, page) => {
  try {
    const response = await api.post(`/report/income`, data);
    // O endpoint retorna um array, mas queremos o primeiro objeto (padrão do mock)
    return Array.isArray(response.data) ? response.data[0] : response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
